import React from 'react';
import * as dates from '@simplybenefits/sb-dates';
import { Text } from '@simplybenefits/sb-ui-library';

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const AccountInformation = ({ accountMeta, customStyle = {} }) => (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', ...customStyle }}>
        <Text bold>
            {accountMeta.company} ({accountMeta.groupNum})
        </Text>

        {
            accountMeta.isStudentGroup ?
                <Text light>
                        Student Group
                </Text>
                :
                null
        }

        <Text
            light
            onClick={() => this._navigateTo(`/advisors/${ accountMeta.advisorID }`)}
            customStyle={{ cursor: 'pointer' }}
        >
                Advisor: {accountMeta.advisor}
        </Text>

        <Text
            light
            customStyle={{ cursor: 'pointer' }}
        >
                Brokerage: {accountMeta.brokerageName}
        </Text>

        {
            accountMeta.effDate &&
            <Text light>
                Effective Date: {dates.getStartOfDay(accountMeta.effDate, 'll')}
            </Text>
        }

        <Text light>
                Secondary Policy #: {accountMeta.secondaryPolicyNumber || 'None'}
        </Text>
    </div>
);

export default AccountInformation;